// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"130":"provider-table","179":"main","443":"about","478":"collection-table","543":"full-page","697":"news"}[chunkId] || chunkId) + "." + {"130":"d4e9c519","161":"c3e0e720","179":"9c10337b","443":"adc5dc76","478":"398d6649","543":"54e57888","697":"876e6711","824":"19432c07","832":"d53373dd"}[chunkId] + ".js";
};